import { createAction } from '@reduxjs/toolkit';

import { get, post } from './axios-request-actions';

import {
  API_CHILD_SITE_PATH,
  API_ROOT_SITE_PATH,
  API_GET_CONTENTS,
  API_GET_SITE_VISIBLE_KEYWORDS,
  API_GET_SITE_AVAILABLE_CHARITIES_FOR_RECOMMENDATION,
  buildApiGetExpertBadges,
  API_GET_SITE_ASSOCIATIONS,
  API_GET_DESIGN_PATHS,
} from 'constants/api-paths';
import {
  GET_ROOT_SITE,
  GET_SITE,
  SIGN_UP_NEWSLETTER,
  GET_CONTENTS,
  GET_SITE_VISIBLE_KEYWORDS,
  GET_AVAILABLE_CHARITIES_FOR_RECOMMENDATION,
  GET_EXPERT_BADGES,
  INIT_CUSTOM_PAGE_CONTENTS,
  GET_SITE_ASSOCIATIONS,
  ActionClearType,
  GET_DESIGN_PATHS,
} from 'constants/redux-actions';

const getRootSite = () => get(GET_ROOT_SITE, API_ROOT_SITE_PATH);

const getSite = (siteSlug) => get(GET_SITE, API_CHILD_SITE_PATH.replace(':siteSlug', siteSlug));

const signUpNewsletter = (apiPath, email) => post(SIGN_UP_NEWSLETTER, null, { EMAIL: email }, { baseURL: apiPath });

const getContents = (siteId, prefixKey) => get(GET_CONTENTS, API_GET_CONTENTS, { siteId, prefixKey }, { data: null });

const getSiteKeywordsForExpertSetting = (siteId) =>
  get(GET_SITE_VISIBLE_KEYWORDS, API_GET_SITE_VISIBLE_KEYWORDS, { siteId }, { data: null });

const getAvailableCharitiesForRecommendation = (siteSlug) =>
  get(
    GET_AVAILABLE_CHARITIES_FOR_RECOMMENDATION,
    API_GET_SITE_AVAILABLE_CHARITIES_FOR_RECOMMENDATION,
    { siteSlug },
    { data: null },
  );

const getExpertBadges = (siteSlug) => get(GET_EXPERT_BADGES, buildApiGetExpertBadges(siteSlug));

const getAssociations = (siteId) => get(GET_SITE_ASSOCIATIONS, API_GET_SITE_ASSOCIATIONS, { siteId }, { data: null });

const initCustomPageContents = (contents) => createAction(INIT_CUSTOM_PAGE_CONTENTS)(contents);
const clearContents = (options) => createAction(ActionClearType(GET_CONTENTS))(options);

const getDesignPaths = () => get(GET_DESIGN_PATHS, API_GET_DESIGN_PATHS);

const siteActions = {
  getRootSite,
  signUpNewsletter,
  getSite,
  getContents,
  getSiteKeywordsForExpertSetting,
  getAvailableCharitiesForRecommendation,
  getExpertBadges,
  initCustomPageContents,
  getAssociations,
  clearContents,
  getDesignPaths,
};

export default siteActions;
